var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShorts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#625b71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.5        C3 4.12 4.12 3 5.5 3h13        C19.88 3 21 4.12 21 5.5v13        c0 1.38-1.12 2.5-2.5 2.5h-13        C4.12 21 3 19.88 3 18.5v-13        M5 6h14v12H5V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9.1c0-.35.3-.65.65-.65h16.7        c.35 0 .65.3.65.65s-.3.65-.65.65H3.65        c-.35 0-.65-.3-.65-.65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12.2v3.6l3.5-1.8Zm-1.2.1        c0-.7.6-1.3 1.3-1.3.2 0 .4.05.6.15        l3.7 1.85c.45.22.7.7.7 1.2        s-.25.98-.7 1.2l-3.7 1.85        c-.2.1-.4.15-.6.15        -.7 0-1.3-.6-1.3-1.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.2c-.3.1-.45.45-.35.75l1.2 3.5        c.1.3.45.45.75.35s.45-.45.35-.75        L6.75 4.55c-.1-.3-.45-.45-.75-.35zm        4 0c-.3.1-.45.45-.35.75l1.2 3.5        c.1.3.45.45.75.35s.45-.45.35-.75        L10.75 4.55c-.1-.3-.45-.45-.75-.35zm        4 0c-.3.1-.45.45-.35.75l1.2 3.5        c.1.3.45.45.75.35s.45-.45.35-.75        L14.75 4.55c-.1-.3-.45-.45-.75-.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShorts);
export default __webpack_public_path__ + "static/media/shorts.4f88ab2e0519e88a63d7904cc3dad6f9.svg";
export { ForwardRef as ReactComponent };